import { Injectable } from '@nestjs/common';
import { StoreReturn } from '../store-return.entity';
import { StoreReturnDTO } from './store-return-dto';

@Injectable()
export class StoreReturnAdapter {
  /**
   * 
   * @param storeReturnDTO 
   * @param isUpdate 
   * @returns 
   */
  public convertDtoToEntity(  storeReturnDTO: StoreReturnDTO,  isUpdate: boolean = false, currentFinancialYear ): StoreReturn {
    const storeReturn = new StoreReturn();
    storeReturn.saleOrderId=storeReturnDTO.saleOrderId;
    storeReturn.storeReturnDate=storeReturnDTO.storeReturnDate;
    storeReturn.saleOrderId=storeReturnDTO.saleOrderId;
    storeReturn.storeReturnNo=currentFinancialYear;
    storeReturn.returnQuantity=storeReturnDTO.returnQuantity;
    storeReturn.itemCategoryId=storeReturnDTO.itemCategoryId;
    storeReturn.itemId=storeReturnDTO.itemId;
    storeReturn.remarks=storeReturnDTO.remarks;
    storeReturn.returnReason=storeReturnDTO.returnReason;
    storeReturn.status=storeReturnDTO.status;
    storeReturn.approvar=storeReturnDTO.approvar;
    storeReturn.unitId=storeReturnDTO.unitId;
    // storeReturn.storeConsumptionId=storeReturnDTO.storeConsumptionId;
    if (isUpdate) {
      storeReturn.updatedUser = storeReturnDTO.updatedUser;
    } else {
      storeReturn.createdUser = storeReturnDTO.createdUser;
    }
   return storeReturn;
  }
  public convertEntityToDto(storeReturnObject: StoreReturn): StoreReturnDTO {
    const storeReturnDTO= new StoreReturnDTO;
    storeReturnDTO.storeReturnId = storeReturnObject.storeReturnId;
    storeReturnDTO.storeReturnNo = storeReturnObject.storeReturnNo;
    storeReturnDTO.saleOrderId = storeReturnObject.saleOrderId;
    storeReturnDTO.storeReturnDate = storeReturnObject.storeReturnDate;
    storeReturnDTO.returnQuantity = storeReturnObject.returnQuantity;
    storeReturnDTO.approvar = storeReturnObject.approvar;
    storeReturnDTO.itemCategoryId = storeReturnObject.itemCategoryId;
    storeReturnDTO.itemId = storeReturnObject.itemId;
    storeReturnDTO.remarks = storeReturnObject.remarks;
    storeReturnDTO.saleOrderId = storeReturnObject.saleOrderId;
    storeReturnDTO.status = storeReturnObject.status;
    storeReturnDTO.createdAt = storeReturnObject.createdAt;
    storeReturnDTO.updatedAt = storeReturnObject.updatedAt;
    storeReturnDTO.createdUser = storeReturnObject.createdUser;
    storeReturnDTO.updatedUser = storeReturnObject.updatedUser;
    storeReturnDTO.versionFlag = storeReturnObject.versionFlag;
    return storeReturnDTO;
  }
}
